module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAAAXNSR0IArs4c6QAAAChJREFUKBVjlDBoXsXw/38oAyHAyBTGREgNsvyo4tHQQA4BZDZJaQMA6j0EPxb2FcUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/normal bolus.png
// module id = 114
// module chunks = 7